<div class="page-content">
  <app-page-header
    [headline]="'DEFINE.DEMO_AND_PROOFS.TITLE'"
    [subheadline]="'DEFINE.DEMO_AND_PROOFS.SUBTITLE'"
    [spaceName]="spaceName">
    <ng-content></ng-content>
  </app-page-header>

  <div class="search-and-filters">
    <div class="search-input-wrapper">
      <input
        type="text"
        class="search-input"
        [placeholder]="'DEFINE.DEMO_AND_PROOFS.SEARCH_PLACEHOLDER' | translate"
        [(ngModel)]="filters.searchText"
        (ngModelChange)="onSearchChange()">
      <svg class="search-icon" width="24" height="24" viewBox="0 0 22.615 22.625" fill="none">
        <path clip-rule="evenodd" d="M7.75 1.5C4.29822 1.5 1.5 4.29822 1.5 7.75C1.5 11.2018 4.29822 14 7.75 14C11.2018 14 14 11.2018 14 7.75C14 4.29822 11.2018 1.5 7.75 1.5ZM0 7.75C0 3.46979 3.46979 0 7.75 0C12.0302 0 15.5 3.46979 15.5 7.75C15.5 8.88569 15.2557 9.96433 14.8168 10.9362L21.8103 17.9297C22.8832 19.0026 22.8832 20.7475 21.8103 21.8204C20.7374 22.8933 18.9925 22.8933 17.9196 21.8204L10.9223 14.8231C9.95406 15.258 8.88029 15.5 7.75 15.5C3.46979 15.5 0 12.0302 0 7.75ZM12.2681 14.0475L18.9803 20.7597C19.4674 21.2468 20.2625 21.2468 20.7496 20.7597C21.2367 20.2726 21.2367 19.4775 20.7496 18.9904L14.0391 12.2798C13.5481 12.9602 12.9495 13.5578 12.2681 14.0475Z" fill="currentColor" fill-rule="evenodd"/>
      </svg>
    </div>

    <div class="filters">
      <div class="filter-dropdown">
        <button class="filter-button" [class.active]="filters.product.length > 0" (click)="toggleDropdown('product')">
          {{ 'DEFINE.DEMO_AND_PROOFS.FILTERS.PRODUCT' | translate }}
          <span class="filter-icon-wrapper">
            <svg class="funnel-icon" width="18" height="25" viewBox="0 0 17.9286 24.5" fill="none">
              <path clip-rule="evenodd" d="M0.0791839 0.41459C0.206228 0.160502 0.465925 0 0.750004 0H17.1786C17.4627 0 17.7224 0.160502 17.8494 0.41459C17.9764 0.668678 17.949 0.972737 17.7786 1.2L11.3571 9.7619V23.75C11.3571 24.0533 11.1744 24.3268 10.8942 24.4429C10.6139 24.559 10.2913 24.4948 10.0768 24.2803L6.7911 20.9946C6.65045 20.854 6.57143 20.6632 6.57143 20.4643V9.7619L0.150004 1.2C-0.0204431 0.972737 -0.0478601 0.668678 0.0791839 0.41459ZM2.25 1.5L7.92143 9.0619C8.0188 9.19173 8.07143 9.34963 8.07143 9.5119V20.1536L9.85715 21.9393V9.5119C9.85715 9.34963 9.90978 9.19173 10.0071 9.0619L15.6786 1.5H2.25Z" fill="currentColor" fill-rule="evenodd"/>
            </svg>
            <span class="filter-badge" *ngIf="filters.product.length > 0">{{ filters.product.length }}</span>
          </span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="activeDropdown === 'product'">
          <div class="dropdown-options">
            <label *ngFor="let option of getFilterOptions('product')" class="filter-option">
              <input type="checkbox" [checked]="isPendingSelected('product', option)" (change)="togglePending('product', option)">
              {{ option }}
            </label>
          </div>
          <div class="dropdown-footer">
            <button class="dropdown-reset" type="button" (click)="resetDropdown('product')">Reset</button>
            <button class="dropdown-apply" type="button" (click)="applyDropdown('product')">Apply</button>
          </div>
        </div>
      </div>

      <div class="filter-dropdown">
        <button class="filter-button" [class.active]="filters.industry.length > 0" (click)="toggleDropdown('industry')">
          {{ 'DEFINE.DEMO_AND_PROOFS.FILTERS.INDUSTRY' | translate }}
          <span class="filter-icon-wrapper">
            <svg class="funnel-icon" width="18" height="25" viewBox="0 0 17.9286 24.5" fill="none">
              <path clip-rule="evenodd" d="M0.0791839 0.41459C0.206228 0.160502 0.465925 0 0.750004 0H17.1786C17.4627 0 17.7224 0.160502 17.8494 0.41459C17.9764 0.668678 17.949 0.972737 17.7786 1.2L11.3571 9.7619V23.75C11.3571 24.0533 11.1744 24.3268 10.8942 24.4429C10.6139 24.559 10.2913 24.4948 10.0768 24.2803L6.7911 20.9946C6.65045 20.854 6.57143 20.6632 6.57143 20.4643V9.7619L0.150004 1.2C-0.0204431 0.972737 -0.0478601 0.668678 0.0791839 0.41459ZM2.25 1.5L7.92143 9.0619C8.0188 9.19173 8.07143 9.34963 8.07143 9.5119V20.1536L9.85715 21.9393V9.5119C9.85715 9.34963 9.90978 9.19173 10.0071 9.0619L15.6786 1.5H2.25Z" fill="currentColor" fill-rule="evenodd"/>
            </svg>
            <span class="filter-badge" *ngIf="filters.industry.length > 0">{{ filters.industry.length }}</span>
          </span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="activeDropdown === 'industry'">
          <div class="dropdown-options">
            <label *ngFor="let option of getFilterOptions('industry')" class="filter-option">
              <input type="checkbox" [checked]="isPendingSelected('industry', option)" (change)="togglePending('industry', option)">
              {{ getFilterLabel('industry', option) }}
            </label>
          </div>
          <div class="dropdown-footer">
            <button class="dropdown-reset" type="button" (click)="resetDropdown('industry')">Reset</button>
            <button class="dropdown-apply" type="button" (click)="applyDropdown('industry')">Apply</button>
          </div>
        </div>
      </div>

      <div class="filter-dropdown">
        <button class="filter-button" [class.active]="filters.discipline.length > 0" (click)="toggleDropdown('discipline')">
          {{ 'DEFINE.DEMO_AND_PROOFS.FILTERS.DISCIPLINE' | translate }}
          <span class="filter-icon-wrapper">
            <svg class="funnel-icon" width="18" height="25" viewBox="0 0 17.9286 24.5" fill="none">
              <path clip-rule="evenodd" d="M0.0791839 0.41459C0.206228 0.160502 0.465925 0 0.750004 0H17.1786C17.4627 0 17.7224 0.160502 17.8494 0.41459C17.9764 0.668678 17.949 0.972737 17.7786 1.2L11.3571 9.7619V23.75C11.3571 24.0533 11.1744 24.3268 10.8942 24.4429C10.6139 24.559 10.2913 24.4948 10.0768 24.2803L6.7911 20.9946C6.65045 20.854 6.57143 20.6632 6.57143 20.4643V9.7619L0.150004 1.2C-0.0204431 0.972737 -0.0478601 0.668678 0.0791839 0.41459ZM2.25 1.5L7.92143 9.0619C8.0188 9.19173 8.07143 9.34963 8.07143 9.5119V20.1536L9.85715 21.9393V9.5119C9.85715 9.34963 9.90978 9.19173 10.0071 9.0619L15.6786 1.5H2.25Z" fill="currentColor" fill-rule="evenodd"/>
            </svg>
            <span class="filter-badge" *ngIf="filters.discipline.length > 0">{{ filters.discipline.length }}</span>
          </span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="activeDropdown === 'discipline'">
          <div class="dropdown-options">
            <label *ngFor="let option of getFilterOptions('discipline')" class="filter-option">
              <input type="checkbox" [checked]="isPendingSelected('discipline', option)" (change)="togglePending('discipline', option)">
              {{ getFilterLabel('discipline', option) }}
            </label>
          </div>
          <div class="dropdown-footer">
            <button class="dropdown-reset" type="button" (click)="resetDropdown('discipline')">Reset</button>
            <button class="dropdown-apply" type="button" (click)="applyDropdown('discipline')">Apply</button>
          </div>
        </div>
      </div>

      <div class="filter-dropdown">
        <button class="filter-button" [class.active]="filters.material.length > 0" (click)="toggleDropdown('material')">
          {{ 'DEFINE.DEMO_AND_PROOFS.FILTERS.MATERIAL' | translate }}
          <span class="filter-icon-wrapper">
            <svg class="funnel-icon" width="18" height="25" viewBox="0 0 17.9286 24.5" fill="none">
              <path clip-rule="evenodd" d="M0.0791839 0.41459C0.206228 0.160502 0.465925 0 0.750004 0H17.1786C17.4627 0 17.7224 0.160502 17.8494 0.41459C17.9764 0.668678 17.949 0.972737 17.7786 1.2L11.3571 9.7619V23.75C11.3571 24.0533 11.1744 24.3268 10.8942 24.4429C10.6139 24.559 10.2913 24.4948 10.0768 24.2803L6.7911 20.9946C6.65045 20.854 6.57143 20.6632 6.57143 20.4643V9.7619L0.150004 1.2C-0.0204431 0.972737 -0.0478601 0.668678 0.0791839 0.41459ZM2.25 1.5L7.92143 9.0619C8.0188 9.19173 8.07143 9.34963 8.07143 9.5119V20.1536L9.85715 21.9393V9.5119C9.85715 9.34963 9.90978 9.19173 10.0071 9.0619L15.6786 1.5H2.25Z" fill="currentColor" fill-rule="evenodd"/>
            </svg>
            <span class="filter-badge" *ngIf="filters.material.length > 0">{{ filters.material.length }}</span>
          </span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="activeDropdown === 'material'">
          <div class="dropdown-options">
            <label *ngFor="let option of getFilterOptions('material')" class="filter-option">
              <input type="checkbox" [checked]="isPendingSelected('material', option)" (change)="togglePending('material', option)">
              {{ getFilterLabel('material', option) }}
            </label>
          </div>
          <div class="dropdown-footer">
            <button class="dropdown-reset" type="button" (click)="resetDropdown('material')">Reset</button>
            <button class="dropdown-apply" type="button" (click)="applyDropdown('material')">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-scroll-content">
    <app-notes [visible]="showNotes"></app-notes>

    <app-bookmarks-collection
      [bookmarkedProductDemoIds]="bookmarkedProductDemos"
      [bookmarkedWorkflowDemoIds]="bookmarkedWorkflowDemos"
      [bookmarkedUseCaseIds]="bookmarkedUseCases"
      (toggleProductDemo)="onBookmarkToggleProductDemo($event)"
      (toggleWorkflowDemo)="onBookmarkToggleWorkflowDemo($event)"
      (toggleUseCase)="onBookmarkToggleUseCase($event)">
    </app-bookmarks-collection>

    <section class="content-group">
      <h2 class="group-title">Demo material</h2>
      <app-product-demos [selectedSolutions]="selectedSolutionNames" [filters]="filters" [bookmarkedIds]="bookmarkedProductDemos" (bookmarkToggle)="onBookmarkToggleProductDemo($event)"></app-product-demos>
      <app-workflow-demos [selectedSolutions]="selectedSolutionNames" [filters]="filters" [bookmarkedIds]="bookmarkedWorkflowDemos" (bookmarkToggle)="onBookmarkToggleWorkflowDemo($event)"></app-workflow-demos>
    </section>

    <section class="content-group">
      <h2 class="group-title">Insights</h2>
      <app-use-cases [selectedSolutions]="selectedSolutionNames" [filters]="filters" [bookmarkedIds]="bookmarkedUseCases" (bookmarkToggle)="onBookmarkToggleUseCase($event)"></app-use-cases>
    </section>

    <app-page-footer></app-page-footer>
  </div>
</div>
